import { motion } from "framer-motion";

export default function QuoteBlock() {
  return (
    <section
      data-testid="quote-section"
      className="relative overflow-hidden bg-rebellion px-6 py-28 md:py-40"
    >
      <span className="pointer-events-none absolute left-4 top-0 select-none font-editorial text-[18rem] leading-none text-white/10 md:text-[26rem]">
        &ldquo;
      </span>

      <div className="relative mx-auto max-w-5xl text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-editorial text-3xl italic leading-tight text-white sm:text-4xl md:text-6xl"
        >
          Political parties turn democracy into a monarchy.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10 font-mono text-sm font-bold uppercase tracking-[0.3em] text-white/70"
        >
          — Election on Mars, Chapter VI
        </motion.p>
      </div>
    </section>
  );
}
